// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-national-security-clearance.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-national-security-clearance',
  title: 'Obtain national security clearance for roles with access to critical government systems',
  description:
    'Where a role under a government framework agreement (SKI 02.15 / 02.17) requires access to critical or sensitive government infrastructure, the relevant employees must hold the appropriate national security clearance obtained through an external government agency. Clearance status must be documented and reviewed when the role or access level changes.',
  category: 'people',
  scfIds: ['SCF-PPL-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'National clearance procedure is documented and published',
    },
    {
      type: 'document-within-sla',
      description: 'Clearance records are current and not overdue for review',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
